import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const facilities = [
  { label: "Weight Training" },
  { label: "Cardio" },
  { label: "Group Classes (Yoga/Zumba)" },
  { label: "Personal Training" },
  { label: "Sauna/Spa" },
  { label: "Nutrition Counselling" },
];

const Key_Services_Modal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="facility_modal"
      backdrop="static"
    >
      <Modal.Body className="facility_modal_body">
        {/* Header */}
        <div className="facility_modal_header">
          <h5>Key Services Offered</h5>
          <span className="close_btn" onClick={onHide}>
            ×
          </span>
        </div>

        {/* List */}
        <div className="facility_list">
          {facilities.map((item, index) => (
            <div className="facility_item" key={index}>
              <div className="facility_left">
                {/* <FontAwesomeIcon icon={item.icon} /> */}
                <span>{item.label}</span>
              </div>

              <input type="checkbox" className="checkbox" />
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Key_Services_Modal;
